/* ==========================================================================
   Architecture & Deployment Options Graph Component
   Matching visual representation (Edge, Centralized, Mobile) - 100% i18n
   ========================================================================== */

import { openArticleModal } from './ArticleModal.js';
import { getLocale, t } from '../locales/i18n.js';

const archTranslations = {
  en: {
    gdprBadge: 'GDPR Compliant',
    edgeTitle: '1. EDGE SOLUTIONS (ON-DEVICE)',
    edgeDesc: 'Includes SED edge software running natively on Axis (ACAP), Hikvision (HEOP), Hanwha (Wisenet 9), and Tondo SphereLink smart city IoT devices.',
    edgeBtn: 'Explore Edge Article →',
    serverTitle: '2. CENTRALIZED SERVER SOLUTION',
    serverDesc: 'Includes standalone SED server architecture connecting microphone arrays, RTSP cameras, and audio streams into central VMS dispatch desks.',
    serverBtn: 'Explore Server Article →',
    mobileTitle: '3. SED MOBILE APPLICATION & SDK',
    mobileDesc: 'Includes live emergency push notifications with sound sample verification and coordinate mapping directly for guards and first responders.',
    mobileBtn: 'Explore Mobile App Article →'
  },
  cs: {
    gdprBadge: 'Soulad s GDPR',
    edgeTitle: '1. EDGE ŘEŠENÍ (NA ZAŘÍZENÍ)',
    edgeDesc: 'Obsahuje software SED běžící přímo na procesorech kamer Axis (ACAP), Hikvision (HEOP), Hanwha (Wisenet 9) a zařízeních Tondo SphereLink.',
    edgeBtn: 'Prozkoumat Edge řešení →',
    serverTitle: '2. CENTRÁLNÍ SERVEROVÉ ŘEŠENÍ',
    serverDesc: 'Připojení mikrofonů k centrálnímu serveru pro rozsáhlé městské a průmyslové instalace bez nutnosti výměny stávající infrastruktury.',
    serverBtn: 'Prozkoumat Serverové řešení →',
    mobileTitle: '3. MOBILNÍ APLIKACE SED A SDK',
    mobileDesc: 'Okamžitá mobilní aplikace pro bezpečnostní personál, ostrahu a hlídky s push notifikacemi incidentů pod 1 sekundu a lokalizací na mapě.',
    mobileBtn: 'Prozkoumat Mobilní aplikaci →'
  },
  de: {
    gdprBadge: 'DSGVO-konform',
    edgeTitle: '1. EDGE-LÖSUNGEN (AUF DEM GERÄT)',
    edgeDesc: 'Beinhaltet SED-Edge-Software, die nativ auf Axis (ACAP), Hikvision (HEOP), Hanwha (Wisenet 9) und Tondo SphereLink Smart-City-Geräten läuft.',
    edgeBtn: 'Edge-Artikel erkunden →',
    serverTitle: '2. ZENTRALISIERTE SERVERLÖSUNG',
    serverDesc: 'Umfasst die Standalone-SED-Serverarchitektur zur Verbindung von Mikrofon-Arrays, RTSP-Kameras und Audioströmen mit VMS-Leitstellen.',
    serverBtn: 'Server-Artikel erkunden →',
    mobileTitle: '3. SED MOBILE ANWENDUNG & SDK',
    mobileDesc: 'Umfasst Live-Notfall-Push-Benachrichtigungen mit Audio-Verifikation und Koordinatenkartierung für Wachpersonal und Einsatzkräfte.',
    mobileBtn: 'App-Artikel erkunden →'
  },
  es: {
    gdprBadge: 'Conformidad RGPD',
    edgeTitle: '1. SOLUCIONES EDGE (EN EL DISPOSITIVO)',
    edgeDesc: 'Incluye software perimetral SED ejecutándose nativamente en dispositivos Axis (ACAP), Hikvision (HEOP), Hanwha (Wisenet 9) y Tondo SphereLink IoT.',
    edgeBtn: 'Explorar artículo Edge →',
    serverTitle: '2. SOLUCIÓN DE SERVIDOR CENTRALIZADO',
    serverDesc: 'Incluye la arquitectura de servidor independiente SED que conecta matrices de micrófonos, cámaras RTSP y flujos de audio con consolas VMS.',
    serverBtn: 'Explorar artículo de Servidor →',
    mobileTitle: '3. APLICACIÓN MÓVIL SED Y SDK',
    mobileDesc: 'Incluye notificaciones push de emergencia en tiempo real con verificación de muestras de audio y mapas de coordenadas para guardias y patrullas.',
    mobileBtn: 'Explorar artículo de App Móvil →'
  },
  pt: {
    gdprBadge: 'Conformidade GDPR / LGPD',
    edgeTitle: '1. SOLUÇÕES EDGE (NO DISPOSITIVO)',
    edgeDesc: 'Inclui software de borda SED executando nativamente em câmeras Axis (ACAP), Hikvision (HEOP), Hanwha (Wisenet 9) e dispositivos IoT Tondo SphereLink.',
    edgeBtn: 'Explorar artigo Edge →',
    serverTitle: '2. SOLUÇÃO DE SERVIDOR CENTRALIZADO',
    serverDesc: 'Inclui arquitetura de servidor SED conectando matrizes de microfones, câmeras RTSP e streams de áudio a centrais VMS.',
    serverBtn: 'Explorar artigo de Servidor →',
    mobileTitle: '3. APLICATIVO MÓVEL SED E SDK',
    mobileDesc: 'Inclui notificações push de emergência em tempo real com verificação de áudio e mapeamento de coordenadas para equipes de segurança.',
    mobileBtn: 'Explorar artigo do App →'
  },
  ar: {
    gdprBadge: 'متوافق مع GDPR',
    edgeTitle: '1. حلول المعالجة الطرفية (Edge)',
    edgeDesc: 'يتضمن برنامج SED الطرفي الذي يعمل أصلياً على كاميرات Axis (ACAP) و Hikvision (HEOP) و Hanwha (Wisenet 9) وأجهزة إنارة المدن الذكية Tondo SphereLink.',
    edgeBtn: 'استكشف مقال الحلول الطرفية ←',
    serverTitle: '2. حل الخادم المركزي (Server)',
    serverDesc: 'يتضمن بنية خادم SED المستقل لربط مصفوفات الميكروفونات وتدفقات كاميرات RTSP مباشرة بمراكز قيادة VMS.',
    serverBtn: 'استكشف مقال الخادم المركزي ←',
    mobileTitle: '3. تطبيق الهواتف الذكية SED وحزمة SDK',
    mobileDesc: 'يتضمن إشعارات طوارئ فورية عبر الهاتف مع التحقق من العينة الصوتية وتحديد الموقع على الخريطة لحراس الأمن وفرق الطوارئ.',
    mobileBtn: 'استكشف مقال التطبيق الذكي ←'
  }
};

export function renderArchitectureGraph() {
  const container = document.createElement('div');
  container.className = 'sed-architecture-diagram';
  container.style.cssText = `
    background: #f8fafc;
    border: 1px solid var(--slate-line);
    border-radius: 16px;
    padding: 2rem 1.25rem;
    margin-top: 1.5rem;
    box-shadow: 0 4px 20px rgba(0,0,0,0.03);
    max-width: 100%;
    box-sizing: border-box;
    overflow: hidden;
  `;

  const lang = getLocale() || 'en';
  const texts = archTranslations[lang] || archTranslations.en;

  container.innerHTML = `
    <div class="sed-arch-grid">
      
      <!-- Option 1: Edge Solutions -->
      <div class="sed-arch-card" data-arch-type="edge" style="background: #ffffff; border: 1.5px solid var(--blue-primary); border-radius: 12px; padding: 1.5rem; display: flex; flex-direction: column; justify-content: space-between; position: relative; cursor: pointer; transition: transform 0.2s ease, box-shadow 0.2s ease;">
        <div style="position: absolute; top: -12px; left: 16px; background: var(--blue-primary); color: #ffffff; font-size: 0.72rem; font-weight: 800; padding: 0.2rem 0.65rem; border-radius: 20px; text-transform: uppercase; letter-spacing: 0.5px;">
          ${texts.gdprBadge}
        </div>
        
        <div>
          <h3 class="sed-card-title">
            ${texts.edgeTitle}
          </h3>

          <!-- Edge Node Topology SVG -->
          <div style="background: #f1f5f9; border-radius: 10px; padding: 1rem; margin-bottom: 1rem;">
            <svg viewBox="0 0 400 180" width="100%" style="display: block; height: auto;">
              <!-- Input Sensors -->
              <g transform="translate(10, 15)">
                <rect x="0" y="0" width="80" height="50" rx="8" fill="#ffffff" stroke="#cbd5e1" stroke-width="1.5"/>
                <rect x="30" y="8" width="20" height="6" rx="2" fill="#35a8df"/>
                <text x="40" y="34" font-size="10" font-weight="700" fill="#0a1727" text-anchor="middle">SED Indoor</text>

                <rect x="0" y="85" width="80" height="50" rx="8" fill="#ffffff" stroke="#cbd5e1" stroke-width="1.5"/>
                <circle cx="40" cy="105" r="10" fill="#0a1727"/>
                <text x="40" y="124" font-size="10" font-weight="700" fill="#0a1727" text-anchor="middle">SED Camera</text>
              </g>

              <!-- Central Edge Chip Processor -->
              <g transform="translate(145, 45)">
                <rect x="0" y="0" width="70" height="70" rx="10" fill="#0a1727" stroke="#35a8df" stroke-width="2"/>
                <rect x="15" y="15" width="40" height="40" rx="4" fill="#35a8df"/>
                <path d="M25 35 L32 42 L45 28" fill="none" stroke="#ffffff" stroke-width="3" stroke-linecap="round"/>
                <text x="35" y="86" font-size="9" font-weight="800" fill="#0a1727" text-anchor="middle">AI EDGE CHIP</text>
              </g>

              <!-- Output Device Nodes -->
              <g transform="translate(265, 15)">
                <rect x="0" y="0" width="80" height="50" rx="8" fill="#ffffff" stroke="#cbd5e1" stroke-width="1.5"/>
                <text x="40" y="30" font-size="10" font-weight="700" fill="#0a1727" text-anchor="middle">SED Outdoor</text>

                <rect x="0" y="85" width="80" height="50" rx="8" fill="#0a1727" stroke="#35a8df" stroke-width="1.5"/>
                <text x="40" y="114" font-size="10" font-weight="800" fill="#ffffff" text-anchor="middle">SED A Software</text>
              </g>

              <!-- Connecting Curves & Lines -->
              <path d="M 90 40 Q 115 40 145 70" fill="none" stroke="#35a8df" stroke-width="2" stroke-dasharray="4,3"/>
              <path d="M 90 110 Q 115 110 145 90" fill="none" stroke="#35a8df" stroke-width="2" stroke-dasharray="4,3"/>
              <path d="M 215 70 Q 240 40 265 40" fill="none" stroke="#35a8df" stroke-width="2"/>
              <path d="M 215 90 Q 240 110 265 110" fill="none" stroke="#35a8df" stroke-width="2"/>

              <!-- Real Time Alert Badge Node -->
              <g transform="translate(350, 70)">
                <circle cx="20" cy="10" r="16" fill="#e6273e"/>
                <path d="M14 10 L20 4 L26 10 M20 4 L20 16" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round"/>
                <text x="20" y="40" font-size="9" font-weight="800" fill="#e6273e" text-anchor="middle">Alert &lt;5s</text>
              </g>
            </svg>
          </div>
          
          <p style="font-size: 0.88rem; color: var(--text-dark); line-height: 1.5; margin-bottom: 1rem;">
            ${texts.edgeDesc}
          </p>
        </div>

        <button class="sed-btn sed-btn-primary" style="width: 100%; font-size: 0.85rem; margin-top: 1rem;">${texts.edgeBtn}</button>
      </div>

      <!-- Option 2: Centralized Server Solution -->
      <div class="sed-arch-card" data-arch-type="server" style="background: #ffffff; border: 1px solid var(--slate-line); border-radius: 12px; padding: 1.5rem; display: flex; flex-direction: column; justify-content: space-between; cursor: pointer; transition: transform 0.2s ease, box-shadow 0.2s ease;">
        <div>
          <h3 class="sed-card-title">
            ${texts.serverTitle}
          </h3>

          <!-- Server Topology SVG -->
          <div style="background: #f1f5f9; border-radius: 10px; padding: 1rem; margin-bottom: 1rem;">
            <svg viewBox="0 0 300 180" width="100%" style="display: block; height: auto;">
              <!-- Microphones Array Left -->
              <g fill="#35a8df">
                <circle cx="30" cy="30" r="12"/>
                <path d="M30 42 L30 52 M24 52 L36 52" stroke="#35a8df" stroke-width="2"/>

                <circle cx="30" cy="90" r="12"/>
                <path d="M30 102 L30 112 M24 112 L36 112" stroke="#35a8df" stroke-width="2"/>

                <circle cx="30" cy="150" r="12"/>
                <path d="M30 162 L30 172 M24 172 L36 172" stroke="#35a8df" stroke-width="2"/>
              </g>

              <!-- Centralized Server Stack -->
              <g transform="translate(110, 30)">
                <rect x="0" y="0" width="80" height="30" rx="4" fill="#0a1727"/>
                <circle cx="16" cy="15" r="4" fill="#35a8df"/>
                <circle cx="30" cy="15" r="4" fill="#35a8df"/>

                <rect x="0" y="40" width="80" height="30" rx="4" fill="#0a1727"/>
                <circle cx="16" cy="55" r="4" fill="#35a8df"/>
                <circle cx="30" cy="55" r="4" fill="#35a8df"/>

                <rect x="0" y="80" width="80" height="30" rx="4" fill="#0a1727"/>
                <circle cx="16" cy="95" r="4" fill="#35a8df"/>
                <circle cx="30" cy="95" r="4" fill="#35a8df"/>
                
                <text x="40" y="130" font-size="9" font-weight="800" fill="#0a1727" text-anchor="middle">SED S SERVER</text>
              </g>

              <!-- Connecting Bus Lines -->
              <path d="M 45 30 L 110 45" stroke="#35a8df" stroke-width="1.5" stroke-dasharray="3,3"/>
              <path d="M 45 90 L 110 55" stroke="#35a8df" stroke-width="1.5" stroke-dasharray="3,3"/>
              <path d="M 45 150 L 110 95" stroke="#35a8df" stroke-width="1.5" stroke-dasharray="3,3"/>

              <path d="M 190 75 L 245 75" stroke="#35a8df" stroke-width="2"/>

              <!-- Dispatch Receiver Node -->
              <g transform="translate(245, 50)">
                <rect x="0" y="0" width="45" height="50" rx="6" fill="#ffffff" stroke="#cbd5e1" stroke-width="1.5"/>
                <text x="22" y="25" font-size="8" font-weight="700" fill="#0a1727" text-anchor="middle">VMS</text>
                <text x="22" y="38" font-size="7" font-weight="600" fill="#64748b" text-anchor="middle">Dispatch</text>
              </g>
            </svg>
          </div>

          <p style="font-size: 0.88rem; color: var(--text-dark); line-height: 1.5; margin-bottom: 1rem;">
            ${texts.serverDesc}
          </p>
        </div>

        <button class="sed-btn sed-btn-primary" style="width: 100%; font-size: 0.85rem; margin-top: 1rem;">${texts.serverBtn}</button>
      </div>

      <!-- Option 3: SED Mobile Application -->
      <div class="sed-arch-card" data-arch-type="mobile" style="background: #ffffff; border: 1px solid var(--slate-line); border-radius: 12px; padding: 1.5rem; display: flex; flex-direction: column; justify-content: space-between; cursor: pointer; transition: transform 0.2s ease, box-shadow 0.2s ease;">
        <div>
          <h3 class="sed-card-title">
            ${texts.mobileTitle}
          </h3>

          <!-- Mobile App Mockup Visual -->
          <div style="background: #f1f5f9; border-radius: 10px; padding: 1rem; margin-bottom: 1rem; text-align: center;">
            <svg viewBox="0 0 200 180" width="100%" style="display: block; margin: 0 auto; max-width: 160px; height: auto;">
              <!-- Smartphone Body -->
              <rect x="35" y="5" width="130" height="170" rx="18" fill="#0a1727" stroke="#35a8df" stroke-width="2"/>
              <!-- Screen Area -->
              <rect x="43" y="20" width="114" height="135" rx="6" fill="#ffffff"/>
              <!-- Speaker & Camera notch -->
              <line x1="85" y1="12" x2="115" y2="12" stroke="#35a8df" stroke-width="2" stroke-linecap="round"/>
              <circle cx="122" cy="12" r="2" fill="#35a8df"/>

              <!-- App UI Header -->
              <rect x="43" y="20" width="114" height="25" fill="#35a8df"/>
              <text x="100" y="36" font-size="8" font-weight="800" fill="#ffffff" text-anchor="middle">SED INCIDENTS</text>

              <!-- Push Notification Alert Box -->
              <g transform="translate(48, 52)">
                <rect x="0" y="0" width="104" height="34" rx="6" fill="#fee2e2" stroke="#ef4444" stroke-width="1"/>
                <text x="8" y="14" font-size="8" font-weight="800" fill="#ef4444">🚨 Gunshot Alert</text>
                <text x="8" y="26" font-size="6.5" font-weight="600" fill="#7f1d1d">Sector 4 • 0.3s ago</text>
              </g>

              <!-- Map Point Icon -->
              <g transform="translate(100, 115)">
                <circle cx="0" cy="0" r="14" fill="rgba(53, 168, 223, 0.2)"/>
                <circle cx="0" cy="0" r="6" fill="#35a8df"/>
                <text x="0" y="22" font-size="7" font-weight="700" fill="#0a1727" text-anchor="middle">GPS Beacon</text>
              </g>
            </svg>
          </div>

          <p style="font-size: 0.88rem; color: var(--text-dark); line-height: 1.5; margin-bottom: 1rem;">
            ${texts.mobileDesc}
          </p>
        </div>

        <button class="sed-btn sed-btn-primary" style="width: 100%; font-size: 0.85rem; margin-top: 1rem;">${texts.mobileBtn}</button>
      </div>

    </div>
  `;

  // Attach modal popup handlers to cards
  container.querySelectorAll('.sed-arch-card').forEach(card => {
    card.addEventListener('click', () => {
      const type = card.getAttribute('data-arch-type');
      if (type === 'edge') {
        openArticleModal('sed-camera-version');
      } else if (type === 'server') {
        openArticleModal('centralized-server-solution');
      } else if (type === 'mobile') {
        openArticleModal('sed-mobile-application');
      }
    });
  });

  return container;
}
